import { useAppSelector } from "@app/hooks";
import { EmeraldToast, ToastPosition, ToastRef } from "@emerald-react/toast";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { removeToast } from "./toastSlice";

/**
 * Global Toast Manager Component
 * Place this at the root of your application to handle all toast notifications
 */
export const GlobalToastManager = () => {
  const toasts = useAppSelector((state) => state.toast?.toasts || []);
  const dispatch = useDispatch();
  const toastRef = useRef<ToastRef>(null);

  useEffect(() => {
    if (toasts.length > 0 && toastRef.current) {
      const latestToast = toasts[toasts.length - 1];
      toastRef.current.show({
        type: latestToast.type,
        title: latestToast.title,
        message: latestToast.message,
      });

      // Auto-remove toast after showing
      const timeout = setTimeout(() => {
        dispatch(removeToast(latestToast.id));
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [toasts, dispatch]);

  return <EmeraldToast ref={toastRef} position={ToastPosition.BOTTOM_LEFT} />;
};
